import Dashboard from "../../../component/Pmc/Dashboard/Dashboard"
import { useHistory } from "react-router-dom";
import { Button } from "../../../style/Button";
const PmsDashboard = () => {
  const history = useHistory();
  const dashboardNextBtnHandler = () => {
    history.push("/Pmc/pendingrx")
  }
  return (
    <>
      <Dashboard />
      <div style={{ textAlign: "right", marginBottom:"50px" }}>
        <Button
          className="button5"
          height="fit-content"
          borderRadius="20px"
          style={{
            padding: "6px 27px",
            fontSize: "18px",
            backgroundImage:
              "linear-gradient(315deg, #7f7f7f 0%, #9e9e9e 74%)",
            color: "white",
            fontWeight: 600,
            textAlign: "center",
            backgroundImage: "linear-gradient(315deg,#4487d1 0%,#009ffd 74%)"
          }}
          onClick={dashboardNextBtnHandler}
        >
          Next
        </Button>
      </div>
    </>
  )
}

export default PmsDashboard